import React, { ReactElement, Ref } from 'react';
import GoogleRecaptcha from 'react-google-recaptcha';

type RecaptchaWrapperProps = {
  onGoogleRecaptchaChange: (recaptchaId: string | null) => void;
  recaptchaRef: Ref<GoogleRecaptcha>;
  recaptchaKey: string;
  recaptchaIsDisabled: boolean;
};

function RecaptchaWrapper({
  onGoogleRecaptchaChange,
  recaptchaRef,
  recaptchaKey,
  recaptchaIsDisabled,
}: RecaptchaWrapperProps): ReactElement {
  if (recaptchaIsDisabled || !recaptchaKey) {
    return <></>;
  }
  return (
    <GoogleRecaptcha
      ref={recaptchaRef}
      sitekey={recaptchaKey}
      size="invisible"
      onChange={onGoogleRecaptchaChange}
    />
  );
}

export { RecaptchaWrapper };
